// extracted by mini-css-extract-plugin
module.exports = {"button":"_1sAID","wrapper":"_20Ucr","label":"_2NCdC","bubble":"_3uddA"};